import React from 'react';
import CharityCard from './CharityCard';
import CharityCardSkeleton from './CharityCardSkeleton';

const CharityGrid = ({ charities, loading, viewMode, onLoadMore, hasMore }) => {
  if (loading && charities?.length === 0) {
    return (
      <div className={`
        ${viewMode === 'grid' ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' : 'space-y-4'
        }
      `}>
        {Array.from({ length: 9 })?.map((_, index) => (
          <CharityCardSkeleton key={index} viewMode={viewMode} />
        ))}
      </div>
    );
  }

  if (charities?.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-12 h-12 text-muted-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">No organizations found</h3>
        <p className="text-muted-foreground mb-4">Try adjusting your filters or search terms</p>
      </div>
    );
  }

  return (
    <div>
      <div className={`
        ${viewMode === 'grid' ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' : 'space-y-4'
        }
      `}>
        {charities?.map((charity) => (
          <CharityCard
            key={charity?.id}
            charity={charity}
            viewMode={viewMode}
          />
        ))}
      </div>
      {/* Load More */}
      {hasMore && (
        <div className="text-center mt-8">
          {loading ? (
            <div className="flex items-center justify-center space-x-2">
              <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
              <span className="text-muted-foreground">Loading more organizations...</span>
            </div>
          ) : (
            <button
              onClick={onLoadMore}
              className="px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
            >
              Load More Organizations
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default CharityGrid;